import React from 'react';
import {FormattedMessage} from 'react-intl';

import {black500} from 'assets/jss/main';

function EmptyState() {
    return (
        <div
            style={{
                color: black500,
                fontSize: '14px',
                fontStyle: 'italic',
                textAlign: 'center',
            }}
        >
            <FormattedMessage id='product.show.log.emptyState' />
        </div>
    );
}

export default EmptyState;
